import axios from 'axios';
import { adminMainUrl } from '../../../Config';

//unused final Quotation with Pagination List
export const getCOASidebar = (token, user_id, ledger_master_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_COA_SIDEBAR_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/chart-of-account/side-bar`;


        try {
            axios.get(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_COA_SIDEBAR_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCOASidebar function (redux):", err);
                dispatch({
                    type: "FIND_COA_SIDEBAR_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCOASidebar function:", error);
            dispatch({
                type: "FIND_COA_SIDEBAR_FAILURE",
                payload: error,
            });
        }
    };
};
//ledger account list
export const getCOALedgerMasterDetail = (token, user_id, ledger_master_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_COA_LEDGER_MASTER_DETAIL_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/chart-of-account/ledger-account-list?ledger_master_id=${ledger_master_id}`;


        try {
            axios.get(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_COA_LEDGER_MASTER_DETAIL_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCOALedgerMasterDetail function (redux):", err);
                dispatch({
                    type: "FIND_COA_LEDGER_MASTER_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCOALedgerMasterDetail function:", error);
            dispatch({
                type: "FIND_COA_LEDGER_MASTER_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};
